import {
  TagTriggerOption,
  UserTriggerOption,
} from './components/controlled-select-based-editor-trigger-content';

export const UserEditorComponents = {
  TriggerOption: UserTriggerOption,
};
export const CreatedByEditorComponent = {
  ...UserEditorComponents,
};
export const TagEditorComponents = {
  TriggerOption: TagTriggerOption,
};
